module.exports = __webpack_public_path__ + "img/numeralia_cedis_2.82777771.png";